export enum FileType {
  None = 0,
  Pdf = 1,
  Txt = 2,
  Png = 3,
  Jpg = 4,
  Gif = 5,
  Doc = 6,
    Xls = 7,
    Mov = 8,
    Mp4 = 9
}
